import React from 'react'
import { ReactComponent as TrashIcon } from '@/assets/icons/trash.svg'
import IconButton from '@/components/ui/Buttons/IconButton'
import { Puff } from '@/components/ui/Loaders'
import { IconButtonProps } from '@/components/ui/Buttons/IconButton/IconButton'

export type DeleteButtonProps = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  isLoading?: boolean
} & IconButtonProps

const DeleteButton = ({ onClick, isLoading, ...props }: DeleteButtonProps) => {
  return (
    <IconButton color={'danger'} onClick={onClick} disabled={isLoading} {...props}>
      {isLoading ? <Puff size={16} /> : <TrashIcon />}
    </IconButton>
  )
}

export default DeleteButton
